export default "__VITE_ASSET__3GFRi2S___"